import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/media/Media.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterNavigation"] */ "/home/ec2-user/website/salontymwebweb/app/components/mobile-componenet/FooterNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWraper"] */ "/home/ec2-user/website/salontymwebweb/app/components/navbar/NavbarWraper.tsx");
